<template>
  <div class="anchor shadow-2xl" @click="scrollTop()" v-if="isVisible">
    <svg width="40" height="48" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.0489 4.5V44M20.0489 4.5L4.5 20.0489M20.0489 4.5L35.5977 20.0489" stroke="white" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: null,
      windowTop: 0,
    };
  },
  methods: {
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onScroll(e) {
      this.windowTop = window.top.scrollY;
    },
  },
  computed: {
    isVisible() {
      var height = window.screen.height;
      return this.windowTop > height;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>


<style lang="scss">
.anchor {
  position: fixed;
  right: 15px;
  bottom: 80px;
  z-index: 999;
  cursor: pointer;
  width: 36px;
  height: 36px;
  background-color: $blue;
  border-radius: 50%;
  display: grid;
  place-items: center;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  svg {
    width: 18px;
    height: auto;
  }

  @screen md {
    right: 30px;
    width: 48px;
    height: 48px;
    bottom: 100px;

    svg {
      width: 24px;
    }
  }
}
</style>
